export default __webpack_public_path__ + "static/media/sticker-oa.4d759acc.png";